import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/v1";

const referralApi = {
    // get referral
    getReferral: async (token) => {
        try {
            const response = await apiFetch(`${BASE_URL}/referrals/get`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }, false);
            const data = await response.json();
            return { 
                status: response.status, 
                data: data 
            };
        } catch (error) {
            console.error("Get referral error:", error);
            throw error;
        }
    },

    // generate referral
    generateReferral: async (token) => {
        try {
            console.log("Calling generate referral API...");
            const response = await apiFetch(`${BASE_URL}/referrals/generate`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                method: 'POST',
            }, false);
            
            console.log("Generate referral response status:", response.status);
            const data = await response.json();
            console.log("Generate referral raw response:", data);
            
            return { 
                status: response.status, 
                data: data 
            };
        } catch (error) {
            console.error("Generate referral error:", error);
            throw error;
        }
    },
    
};

export default referralApi;

